import { styled as t } from "@mui/joy";
import o from "@mui/joy/Stack";
import m from "@mui/joy/Typography";
const e = t(o)({ maxWidth: "400px", alignItems: "center", textAlign: "center" }), i = t(o)(({ theme: t2 }) => ({ gap: t2.spacing(1) })), p = t(m)({ whiteSpace: "nowrap" });
export {
  e as Content,
  i as TextWrapper,
  p as Title
};
//# sourceMappingURL=styled.js.map
